import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPoint, EntryPointComponent } from 'react-relay';

type HelpCenterSettingsCustomerAccessAppEntryPointComponent = EntryPointComponent<
	{},
	{},
	{},
	{} | null
>;

export const helpCenterSettingsCustomerAccessAppEntryPoint: EntryPoint<
	HelpCenterSettingsCustomerAccessAppEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<HelpCenterSettingsCustomerAccessAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-settings-customer-access-app" */ './HelpCenterSettingsCustomerAccessPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
